/** Shapes returned by the endpoints in `src/api/invoice.js`. */

import type { StatusValue } from "src/components/common/StatusBadge";

/** Invoice lifecycle, matching spec §2.5 (`partial` = paid, but not in full). */
export type InvoiceStatus = "pending" | "partial" | "paid";

export const invoiceStatusBadge = (status?: string): StatusValue => {
	if (status === "paid") return "paid";
	if (status === "partial") return "partial";
	return "pending";
};

export interface InvoiceRow {
	uuid: string;
	id?: number;
	invoice_id?: string;
	first_name?: string;
	last_name?: string;
	balance?: number | string;
	total_amount?: number | string;
	due_date?: string;
	created_at?: string;
	status?: InvoiceStatus | string;
	payment_method?: "transfer" | "offline" | string;
	customer_id?: number | string;
}

export interface InvoiceItem {
	id?: number | string;
	qty?: number;
	product_price?: number | string;
	amount?: number | string;
	product?: { name?: string };
}

export interface InvoiceDetailData extends InvoiceRow {
	customer?: {
		first_name?: string;
		last_name?: string;
		email?: string;
		phone?: string;
	};
	items?: InvoiceItem[];
	amount?: number | string;
	discount_amount?: number | string;
	vat?: number | string;
	transaction_fee?: number | string;
	transaction_amount?: number | string;
}

/** A row from `GET /payments`. */
export interface PaymentRow {
	uuid?: string;
	invoice_uuid?: string;
	invoice_number?: string;
	first_name?: string;
	last_name?: string;
	payment_method?: string;
	amount?: number | string;
	created_at?: string;
	status?: string;
}
